import { useCallback } from 'react';
import { UsePostParams, usePut } from '../../../../api';

const ENDPOINT = '/insights/saveConfigurationStatus';

export type UseSaveExposuresConfigurationStatusParams = UsePostParams<{}, {}>;

const useSaveExposuresConfigurationStatus = (usePostParams: UseSaveExposuresConfigurationStatusParams) => {
    const { put, ...rest } = usePut(usePostParams);

    const saveConfigurationStatus = useCallback(
        (params: { id: string; status: boolean }) => {
            const url = `${ENDPOINT}/${params.id}/${params.status}`;
            return put(url, params);
        },
        [put]
    );

    return {
        ...rest,
        saveConfigurationStatus
    };
};

export default useSaveExposuresConfigurationStatus;
